import {
  LOAD_HOSTING_SETTINGS,
  LOAD_HOSTING_SETTINGS_FAIL,
  LOAD_HOSTING_SETTINGS_SUCCESS,
  LoadHostingSettings,
  LoadHostingSettingsFail,
  LoadHostingSettingsSuccess
} from '../actions/hosting-settings.action';
import {HostingSettingsAction} from "../actions";

export interface IHostingEntityState {
  entities: {[websiteId: number]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IHostingSettingsState {
  entities: {[websiteId: number]: IHostingEntityState};
}

export const initialState: IHostingSettingsState = {
  entities: {}
};

export function reducer(state: IHostingSettingsState = initialState, action: HostingSettingsAction): IHostingSettingsState {
  let payload: any;

  switch (action.type) {

    case LOAD_HOSTING_SETTINGS:
      payload = (<LoadHostingSettings>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };
    case LOAD_HOSTING_SETTINGS_SUCCESS:
      payload = (<LoadHostingSettingsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_HOSTING_SETTINGS_FAIL:
      payload = (<LoadHostingSettingsFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
